
<v-menu offset-y>
	<template #activator="{ on, attrs }">
		<v-badge
			class="unread-badge"
			:style="{ '--badge-text-color': contrastColorOnPrimary }"
			:content="unreadcount"
			:value="unreadcount"
			color="primary"
			bottom
			overlap
			bordered
		>
			<v-btn color="accent" :class="['mr-4', 'button-block', 'font-weight-bold', contrastOnAccent]" depressed width="100%" v-bind="attrs" v-on="on">
				<v-icon :color="contrastColorOnAccent"> mdi-chat </v-icon>
			</v-btn>
		</v-badge>
	</template>
	<v-list>
		<v-list-item v-for="(unreadChat, index) in unreadChats" :key="index" @click="openMessageDialog(unreadChat.sentByID, unreadChat.receivedByID, unreadChat.name)">
			<!-- <v-list-item-icon width="60" height="60">
				<v-skeleton-loader v-if="!unreadChat[index].avatar" type="avatar" :loading="true" width="60" height="60"> </v-skeleton-loader>
				<v-img v-else-if="unreadChat[index].avatar" :src="unreadChat[index].avatar"></v-img>
			</v-list-item-icon> -->
			<div class="unreadItems">
				<v-list-item-title
					><strong>{{ unreadChat.name }}</strong></v-list-item-title
				>
				<v-avatar color="primary" size="20">
					<span :class="['text-subtitle-2', contrastOnPrimary]">{{ unreadChat.count }}</span>
				</v-avatar>
			</div>
		</v-list-item>
	</v-list>
</v-menu>
